import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import I18n from 'PMT/i18n/I18n';

import RoutingEnum from 'constants/RoutingEnum';

import { DateUtils, NotificationUtils } from 'PMT/utils';
import Listener from 'PMT/flux/Listener';
import Events from 'constants/Events';
import { Constants, Config } from 'constants';

import {
  RestaurantStore,
  SessionStore,
  OrdersListStore,
  OrderSettingsStore,
} from 'stores';

import { OrderAction, RestaurantAction, RouteAction } from 'actions';

import { OrderSettings, Order } from 'PMT/entities/order';
import RestaurantMultipart from 'PMT/entities/RestaurantMultipart';

// -- views
import Ariane from 'PMT/components/Ariane';
import AbstractComponent from 'components/AbstractComponent';
import OrdersOnGoingListView from './ordersOnGoing/OrdersOnGoingListView';
import { Tabs, Tab } from 'react-bootstrap';
import OrdersHistoryPage from './ordersHistory/OrdersHistoryPage';
import NotifyOrdersToMakeModal from './components/notifyOrdersToMakeModal';

let _timer = null;

export default class OrdersListPage extends AbstractComponent {

  static Tab = {
    ON_GOING: 'on-going',
    HISTORY: 'history'
  };

  state = {
    restaurant: null,

    ordersList: null,

    orderSettings: null,

    ordersToNotify: [],

    // we reduce from one hour just in case.
    lastUpdateTime: DateUtils.getTodayTimestampAsMilliseconds() - DateUtils.HOUR_AS_MILLISECONDS,
  }

  constructor() {
    super();

    this.arianeIcon = 'fa-line-chart';
    this.arianeDetails = [
      {
        name: I18n.tr('menu.order'),
        link: null
      }
    ];
  }

  componentDidMount() {
    if (!RestaurantStore.getRestaurant().haveFeatureOrder()) {
      RouteAction.redirectToFeatureNonActivated();
      return;
    }

    RestaurantStore.addListeners(this.restaurantStoreListeners);
    this.loadRestaurant();

    OrdersListStore.addListeners(this.ordersListListeners);

    OrderSettingsStore.addListener(Events.ON_LOAD_ORDER_SETTINGS_SUCCESS, this.onLoadOrderSettings);
    OrderSettingsStore.addListener(Events.ON_UPDATE_ORDER_SETTINGS_SUCCESS, this.onLoadOrderSettings);


    OrderAction.loadOrderSettings();


    this.loadOrdersListOnGoing();
  }

  componentWillUnmount() {
    RestaurantStore.removeListeners(this.restaurantStoreListeners);

    OrdersListStore.removeListeners(this.ordersListListeners);

    clearTimeout(_timer);
  }

  get ordersListListeners(): Array<Listener> {
    return [
      new Listener(Events.ON_RETRIEVE_ORDERS_LIST_SUCCESS, this.onOrdersListChange),
      new Listener(Events.ON_RETRIEVE_ORDERS_LIST_FAILURE, this.onError),

      new Listener(Events.UPDATE_ORDER_SUCCESS, this.onUpdateOrderSuccess),
      new Listener(Events.UPDATE_ORDER_FAILURE, this.onError)
    ];
  }

  get restaurantStoreListeners(): Array<Listener> {
    return [
      new Listener(Events.LOAD_RESTAURANT_SUCCESS, this.onRestaurantLoad),
      new Listener(Events.UPDATE_RESTAURANT_SUCCESS, this.onRestaurantUpdate),
      new Listener(Events.LOAD_RESTAURANT_FAILURE, this.onError),
    ];
  }

  loadRestaurant = () => {
    this.showLoading();
    RestaurantAction.retrieveCurrentRestaurant();
  };

  /**
   * Load the orders created during the given timelapse.
   */
  loadOrdersListOnGoing(displayLoading: boolean = true) {
    if (displayLoading) {
      this.showLoading();
    }
    OrderAction.loadOnGoingOrdersList();
  }

  /**
   * Load the orders created during the given timelapse.
   */
  loadOrdersListByModificationDate(fromTime: number, toTime: number, displayLoading: boolean = true) {
    if (displayLoading) {
      this.showLoading();
    }
    OrderAction.loadOrdersListByModificationDate(fromTime, toTime);
  }

  onRestaurantLoad = () => {
    const restaurant: Restaurant = RestaurantStore.getRestaurant().copy();

    this.setState({
      restaurant,
      loading: _.isNull(this.state.ordersList) || _.isNull(this.state.orderSettings),
    });
  };

  onRestaurantUpdate = () => {
    const restaurant: Restaurant = RestaurantStore.getRestaurant().copy();

    this.setState({
      restaurant,
      loading: _.isNull(this.state.ordersList) || _.isNull(this.state.orderSettings),
    });
  };

  /**
   *
   * @param  boolean calculLastUpdateTime Define if we have to calcul the latest update time.
   *                                      Must be true ONLY if the function is called right after
   *                                      a call to the API to retrieve the new orders
   *                                      (OrderAction.loadOrdersListByModificationDate)
   */
  updateListOnState(calculLastUpdateTime: boolean = false) {
    const ordersList = OrdersListStore.getOrdersList();

    //
    //
    //

    // lastUpdateTime is the timestamp of the latest updated order (default: now minus 5 minutes).
    // we subtract 5 minutes just in case.
    let lastUpdateTime;
    if (calculLastUpdateTime) {
      lastUpdateTime = moment().subtract(5, 'minutes').valueOf();
      const lastUpdatedOrder = ordersList.getLastUpdateOrder();
      if (!_.isNull(lastUpdatedOrder)) {
        // add 1 milliseconds to not retrieve again this order.
        lastUpdateTime = lastUpdatedOrder.modificationDate.valueOf() + 1;
      }
    } else {
      // we don't re-calculate the last update time.
      // When we receive an updated order for example, we don't want to because we couldn't have
      // the new orders made between the lastUpdateTime and the order's put time (who would
      // become the new lastUpdateTime).
      lastUpdateTime = this.state.lastUpdateTime;
    }

    // lastUpdateTime can't be more than 31 days, otherwise api returns and error
    const updateLimit = moment().valueOf() - DateUtils.DAY_AS_MILLISECONDS * 30
    if (lastUpdateTime < updateLimit) {
      lastUpdateTime = updateLimit
    }

    //
    // find orders to notify
    //

    // -- get all orders that could be notify
    let ordersToNotify = [];
    if (!_.isNil(this.state.orderSettings)) {
      const manufactureDelay = this.state.orderSettings.manufactureDelay;

      // get on going
      ordersToNotify = ordersList.getOnGoingOrders();

      // filter not later
      ordersToNotify = _.filter(ordersToNotify, (order: Order) => {
        return order.isSent();
      });

      // remove already displayed
      ordersToNotify = _.filter(ordersToNotify, (order: Order) => {
        const delay = this.state.orderSettings.getOrderDelay(order.mode);
        return order.getPriority(delay) !== Order.Priority.LATER;
      });
    }

    //
    // update state
    //
    this.setState({
      ordersList,
      loading: _.isNull(this.state.restaurant) || _.isNull(this.state.orderSettings),
      lastUpdateTime,
      ordersToNotify,
    }, () => {
      this.updateBadge();
    });

    this.resetTimer();
  }

  updateBadge() {
    // Set badge on tab
    // -- set badge for waiting bookings
    const nb = this.state.ordersList.getOnGoingOrders().length;
    const element = $('#orders_list_page__tabs-tab-on-going');

    if (nb > 0) {
      element
      .html(`${I18n.tr('order.list.tabs.on_going').toUpperCase()} <span class="badge badge-error">${nb}<span>`);
    } else {
      element.html(I18n.tr('order.list.tabs.on_going').toUpperCase());
    }
  };

  //
  // Api events - order settings
  //
  onLoadOrderSettings = () => {
    this.setState({
      orderSettings: OrderSettingsStore.getOrderSettings(),
      loading: _.isNull(this.state.ordersList) || _.isNull(this.state.restaurant),
    });
  };

  //
  // Api events - order
  //

  onUpdateOrderSuccess = () => {
    this.updateListOnState(false);
  };

  onOrdersListChange = () => {
    this.updateListOnState(true);
  }

  handleUpdateRestaurantStatus = (status) => {
    const restaurantMultipart = new RestaurantMultipart();
    restaurantMultipart.id = this.state.restaurant.id;
    restaurantMultipart.status = status

    this.showLoading(() => {
      RestaurantAction.updateRestaurant(restaurantMultipart);
    });

  }

  onError = () => {
    this.resetTimer();
    this.setState({
      loading: false,
      error: OrdersListStore.getApiError()
    })
  };

  resetTimer() {
    clearTimeout(_timer);
    _timer = setTimeout(
      this.onTimerDone,
      Constants.Order.DELAY_CHECK_NEW_ORDERS
    );
  }

  //
  // Timer
  //

  onTimerDone = () => {
    const fromTime = this.state.lastUpdateTime;
    const toTime = moment().valueOf();
    this.loadOrdersListByModificationDate(fromTime, toTime, false);
  };

  //
  // Tabs
  //

  get defaultTabKey(): string {

    if (!_.isEmpty(this.props.location.search)) {
      const params = new URLSearchParams(this.props.location.search);
      const tabQuery = params.get('tab');
      if (tabQuery) {
        return tabQuery;
      }
    }

    return OrdersListPage.Tab.ON_GOING;
  }

  onTabChange = (activeKey: string) => {
    if (!_.isUndefined(activeKey)) {
      /*
       * Update the query params.
       */
      this.onChangeQueryUrl({
        tab: activeKey
      });

    }
  };

  //
  //
  //

  renderWarnings() {
    return (
      <div>
        {this.state.restaurant && this.state.restaurant.status === 'ARCHIVED' && (
            <p className="bg-warning"
               style={{padding: 16, marginTop: 16,}}>{I18n.tr(
                'restaurant_edit.configuration.status.ARCHIVED.tip')}</p>
        )}
      </div>
    )
  }

  renderNotifyOrdersToMakeModal() {
    const ordersToNotify: Array<Order> = this.state.ordersToNotify;
    if (_.isNil(ordersToNotify) || _.isEmpty(ordersToNotify)) {
      return (null);
    }

    return (
      <NotifyOrdersToMakeModal
        show
        orders={ordersToNotify}
        orderSettings={this.state.orderSettings}
        currencyCode={this.state.restaurant.currency}
      />
    );
  }

  renderBody() {
    const isLoading = _.isNull(this.state.restaurant)
      || _.isNull(this.state.ordersList)
      || _.isNull(this.state.orderSettings)

    return (
      <Tabs
        defaultActiveKey={this.defaultTabKey}
        id="orders_list_page__tabs"
        onSelect={this.onTabChange}
      >
        <Tab
          eventKey={OrdersListPage.Tab.ON_GOING}
          title={I18n.tr('order.list.tabs.on_going').toUpperCase()}
        >
          {this.renderWarnings()}
          {!this.state.apiError && this.renderApiErrorBlock()}
          {!isLoading && !this.state.apiError && (
            <OrdersOnGoingListView
              restaurant={this.state.restaurant}
              location={this.props.location}
              ordersList={this.state.ordersList}
              orderSettings={this.state.orderSettings}
              onUpdateRestaurantStatus={this.handleUpdateRestaurantStatus}
            />
          )}
        </Tab>

        <Tab
          eventKey={OrdersListPage.Tab.HISTORY}
          title={I18n.tr('order.list.tabs.history').toUpperCase()}
        >
          {this.renderWarnings()}
          {/* load the tab only if we have to go in. */}
          {this.defaultTabKey === OrdersListPage.Tab.HISTORY && !isLoading && (
            <div className="top-buffer-30">
              <OrdersHistoryPage
                location={this.props.location}
              />
            </div>
          )}
        </Tab>

      </Tabs>
    );
  }

  render() {
    return (
      <div className="orders_list_page">
        <Ariane icon={this.arianeIcon} details={this.arianeDetails} />

        {this.renderBody()}
        {this.renderLoading()}

        {this.renderNotifyOrdersToMakeModal()}
      </div>
    );
  }

}
